import { Chassis } from './../shared/models/chassis.interface';
import { ChassisLock } from './../shared/models/chassis-lock.interface.';
import { SignalrBroadcaster } from "../pb-screen/helpers/signalr.broadcaster";
import { Injectable } from "@angular/core";
import { NgRedux } from "@angular-redux/store";
import { IAppState } from "../store/IAppState";
import { ChannelEventFactory } from "../pb-screen/services/channel.event.factory";
import { ChannelService } from "../pb-screen/services/channel.service";
import { SharedService } from "../shared/services/shared.service";
import { PlanningBoardService, ViewMode } from "./services/planningBoard.service";
import { ActionKeys } from "../pb-screen/action.keys";
import { PlanningBlock } from "../pb-screen/models/planning-block/planning-block.interface";
import { Quote } from "../static/models/quote.interface";
import { DeleteToFromCapacity, TransportOrder } from "../pb-screen/models/transport-order/transport-order.interface";
import { PlanningConflict } from "../pb-screen/models/planning-conflict.interface";
import { ApplicationUser } from "../pb-screen/models/application.user.interface";
import { SharedActions } from "../shared/shared.actions";
import { UserFeedbackService } from "../services/user-feedback.service";
import { UsersAuthorizationService } from "../users-authorizations/user-authorization.service";
import { environment } from "../../environments/environment";


@Injectable()
export class PlanningBoardActions extends SignalrBroadcaster {
  constructor(
    ngRedux: NgRedux<IAppState>,
    channelEventFactory: ChannelEventFactory,
    channelService: ChannelService,
    public readonly sharedActions: SharedActions,
    private readonly sharedService: SharedService,
    private readonly planningBoardService: PlanningBoardService,
    private readonly userFeedbackService: UserFeedbackService,

  ) {
    super(ngRedux, channelEventFactory, channelService);
  }

  public storeDataForPlanningGrid(endDate: string, startDate: string, truckDepartment: string, zone: string, groups: string, defaultPlanSorting: string) {
    this.planningBoardService.getPlanningForDate(endDate, startDate, truckDepartment, zone, groups, defaultPlanSorting == "driver" ? ViewMode.Driver : ViewMode.Truck).subscribe((planningData) => {

      this.ngRedux.dispatch({
        type: ActionKeys.STORE_PLANNING_FOR_DATE_SUCCESS,
        planningData
      });

    });

  }


  public storeUnplannedPlanningBlocks(zones, groups, startDate, endDate, transportTypes, createMonitor = true) {
    this.planningBoardService.getUnplannedPlanningBlocks(zones, groups, startDate, endDate, transportTypes).subscribe((unplannedPbs) => {
      this.ngRedux.dispatch({
        type: ActionKeys.STORE_UNPLANNED_PBS_SUCCESS,
        unplannedPbs
      });

    });

  }

  public storeOpenTosForDate(planningDateFrom, planningDateUntil, planningGroups) {
    this.planningBoardService.getOpenTosForDate(planningDateFrom, planningDateUntil, planningGroups)
      .subscribe((openTosForDate) => {
      this.ngRedux.dispatch({
        type: ActionKeys.STORE_OPEN_TOS_FO_DATE_SUCCESS,
        openTosForDate
      });
    });
  }

  public updatedUnplannedDisplay(usedPlanningBlocks) {
    this.ngRedux.dispatch({
      type: ActionKeys.UPDATE_UNPLANNED_DISPLAY,
      usedPlanningBlocks: usedPlanningBlocks
    });
  }

  public UpdateOrderLinesDisplay(updatedOrderlines) {

    this.ngRedux.dispatch({
      type: ActionKeys.UPDATE_ORDERLINES_DISPLAY,
      updatedOrderlines: updatedOrderlines
    });
  }

  public setSelectedPbsUnplanned(planningBlocks: PlanningBlock[]) {
    this.ngRedux.dispatch({
      type: ActionKeys.SET_SELECTED_PBS_UNPLANNED,
      selectedPbsToPlan: planningBlocks
    });
  }

  public setSelectedPbsFromPlanBoard(selectedPbsFromPlanBoard) {
    super.dispatchAndTransmitAction({
      type: ActionKeys.SELECT_PBS_FROM_PLAN_BOARD,
      selectedPbsFromPlanBoard
    });
  }

  public setSelectionType(selectionType) {
    super.dispatchAndTransmitAction({
      type: ActionKeys.STORE_SELECTION_TYPE,
      selectionType
    });
  }

  public setSelectedQuotes(quotes: Quote[]) {
    this.ngRedux.dispatch({
      type: ActionKeys.STORE_SELECTED_QUOTES,
      quotes
    });
  }

  /* Week Planning */
  public storeDataForWeekPlanning(user: ApplicationUser, withSequenceDates = false, withReminders = false) {
    this.sharedActions.setLoading(true);
    if (environment.enableAuthorizationModule && user.defaultPlanGroups.length == 0) {
      this.sharedActions.setLoading(false);
      this.userFeedbackService.showErrorMessage("SHARED.PLEASE_SELECT_PLANNING_GROUPS");
      return;
    }

    this.planningBoardService.getPlanningForWeekPlanning(
      user.defaultPlanDateRange.defaultPlanDateUntil,
      user.defaultPlanDateRange.defaultPlanDateFrom,
      user.defaultTruckDepartments.join(","),
      user.defaultPlanZone,
      user.defaultPlanGroups.join(","),
      user.weekPlanningPreferences.tabletMode ? "" : user.truckFilters.truckType,
      user.weekPlanningPreferences.tabletMode ? "" : user.truckFilters.truckSubType,
      withSequenceDates,
      withReminders,  user.defaultPlanSorting =="driver" ? ViewMode.Driver : ViewMode.Truck
    ).subscribe(weekPlanningData => {
      this.ngRedux.dispatch({
        type: ActionKeys.STORE_WEEK_PLANNING_DATA_SUCCESS,
        weekPlanningData
      });
      this.sharedActions.setLoading(false);

    } , (erro)=> {

      this.userFeedbackService.showErrorMessage("SHARED.ERROR_LOADING_WEEK_PLANNING_DATA");
      this.sharedActions.setLoading(false);

    });
  }

  public storeUnplannedPlanningBlocksForWeekPlanning(zones, groups, startDate, endDate, transportTypes) {
    if(environment.enableAuthorizationModule && groups.length == 0) {
      return;
    }
    this.planningBoardService.getUnplannedPlanningBlocksForWeekPlanning(zones, groups, startDate, endDate, transportTypes)
      .subscribe((unplannedPbsForWeekPlanning) => {
      this.ngRedux.dispatch({
        type: ActionKeys.STORE_WEEK_UNPLANNED_PBS_SUCCESS,
        unplannedPbsForWeekPlanning
      });
    });

  }

  public setSelectedOrderlinesFromPlanBoard(selectedOrderlinesFromBoard: any[]) {
    this.ngRedux.dispatch({
      type: ActionKeys.SET_SELECTED_ORDERLINES_FROM_PLANBOARD,
      selectedOrderlinesFromBoard
    });
  }

  public setSelectedCapacityFromPlanBoard(selectedCapacityFromPlanBoard: any) {
    this.ngRedux.dispatch({
      type: ActionKeys.SET_SELECTED_CAPACITY_FROM_PLANBOARD,
      selectedCapacityFromPlanBoard
    });
  }

  /* Planning Board Monitor Actions */

  public updateUnplannedPbsSelection(source, data: PlanningBlock[]) {

    var appState = this.ngRedux.getState();

    var oldSelection = appState.selectedPbsToPlan;

    if (oldSelection.length > 0) {
      if (source == "update") {
        data.forEach((item) => {
          let oldPb = oldSelection.filter((pb) => {
            return pb.id == item.id;
          })[0];
          if (oldPb) {
            let index = oldSelection.indexOf(oldPb);
            oldSelection[index] = item;
          }
        });
      }
      if (source == "delete") {
        oldSelection = oldSelection.filter((pb) => {
          return data.filter((item) => {
            return item.id == pb.id;
          }).length !== 0;
        });
      }


    }


    this.ngRedux.dispatch({
      type: ActionKeys.SET_SELECTED_PBS_UNPLANNED,
      selectedPbsToPlan: oldSelection
    });
  }

  public updatePlanningBoardDisplay(action, data) {
    if (action == ActionKeys.STORE_PLANNING_FOR_DATE_SUCCESS) {
      this.ngRedux.dispatch({
        type: ActionKeys.STORE_PLANNING_FOR_DATE_SUCCESS,
        planningData: data
      });
    }

    if (action == ActionKeys.STORE_UNPLANNED_PBS_SUCCESS) {

      this.ngRedux.dispatch({
        type: ActionKeys.STORE_UNPLANNED_PBS_SUCCESS,
        unplannedPbs: data
      });

    }
  }

  public UpdatePlanningDisplay(updatedTransportOrders: TransportOrder[], updateToSelection: boolean = true) {
    this.dispatchAndTransmitAction({
      type: ActionKeys.UPDATE_PLANNING_DISPLAY,
      updatedItems: updatedTransportOrders,
      updateToSelection
    });

    let pbsToUpdate: PlanningBlock[] = [];
    updatedTransportOrders.forEach(transportOrder => {
      pbsToUpdate.push(...transportOrder.planningBlocks);

    });

    this.sharedActions.updatePBScreen(pbsToUpdate);
  }

  public removeTosFromCapacity(tosToBeDeleted: DeleteToFromCapacity[]) {
    this.dispatchAndTransmitAction({
      type: ActionKeys.REMOVE_TOS_FROM_CAPACITY,
      tosToBeDeleted
    });
  }

  /** Re-fetch the full board data and merge only the affected slots (by truck ID).
   *  Uses the same API as the initial board load to guarantee identical data shapes. */
  public refreshAffectedSlots(truckIds: string[], driverIds: string[], planDate: string) {
    const appUser = this.ngRedux.getState().applicationUser;
    if (!appUser) return;

    this.planningBoardService.getPlanningForDate(
      appUser.defaultPlanDate, appUser.defaultPlanDate,
      appUser.defaultTruckDepartments.join(','),
      appUser.defaultPlanZone, appUser.defaultPlanGroups.join(','),
      appUser.defaultPlanSorting == 'driver' ? ViewMode.Driver : ViewMode.Truck
    ).subscribe(fullBoard => {
      const affectedIds = new Set([...truckIds, ...driverIds].filter(Boolean));
      const slotResults = fullBoard
        .filter(cs => affectedIds.has(String(cs.truck?.id || '')) || affectedIds.has(String(cs.driver?.id || '')))
        .map(cs => ({
          truckName: cs.truck?.id ? String(cs.truck.id) : null,
          driverName: cs.driver?.id ? String(cs.driver.id) : null,
          transportOrders: cs.transportOrders || []
        }));
      this.ngRedux.dispatch({
        type: ActionKeys.MERGE_SLOT_TRANSPORT_ORDERS,
        slotResults
      });
    });
  }

  /** Week-planning equivalent of refreshAffectedSlots.
   *  Re-fetches the full week board and merges only the affected slots (by truck/driver ID).
   *  Uses getPlanningForWeekPlanning so the returned slot TOs cover the full week range,
   *  preventing loss of other-day TOs when the merge replaces a slot's transportOrders. */
  public refreshAffectedSlotsForWeek(truckIds: string[], driverIds: string[]) {
    const appUser = this.ngRedux.getState().applicationUser;
    if (!appUser) return;

    this.planningBoardService.getPlanningForWeekPlanning(
      appUser.defaultPlanDateRange.defaultPlanDateUntil,
      appUser.defaultPlanDateRange.defaultPlanDateFrom,
      appUser.defaultTruckDepartments.join(','),
      appUser.defaultPlanZone,
      appUser.defaultPlanGroups.join(','),
      appUser.weekPlanningPreferences?.tabletMode ? '' : appUser.truckFilters?.truckType,
      appUser.weekPlanningPreferences?.tabletMode ? '' : appUser.truckFilters?.truckSubType,
      false,
      environment.showReminders,
      appUser.defaultPlanSorting == 'driver' ? ViewMode.Driver : ViewMode.Truck
    ).subscribe(fullBoard => {
      const affectedIds = new Set([...truckIds, ...driverIds].filter(Boolean));
      const slotResults = fullBoard
        .filter(cs => affectedIds.has(String(cs.truck?.id || '')) || affectedIds.has(String(cs.driver?.id || '')))
        .map(cs => ({
          truckName: cs.truck?.id ? String(cs.truck.id) : null,
          driverName: cs.driver?.id ? String(cs.driver.id) : null,
          transportOrders: cs.transportOrders || []
        }));
      this.ngRedux.dispatch({
        type: ActionKeys.MERGE_SLOT_TRANSPORT_ORDERS,
        slotResults
      });
    });
  }

  public setLoading(loading) {
    this.dispatchAction({
      type: ActionKeys.SET_LOADING,
      loading: loading
    });
  }

  public setOrderlinesDockLoading(loading: boolean) {
    this.dispatchAction({
      type: ActionKeys.SET_ORDERLINES_DOCK_LOADING,
      loading: loading
    });
  }

  public setSelectedQuotelinesFromBoard(selectedQuotelinesFromBoard: any[]) {
    this.ngRedux.dispatch({
      type: ActionKeys.SET_SELECTED_QUOTELINES_FROM_BOARD,
      selectedQuotelinesFromBoard
    });
  }

  public setPlanningConflictsForDock(conflicts: PlanningConflict[]) {
    this.ngRedux.dispatch({
      type: ActionKeys.PLANNING_CONFLICTS_FOR_DOCK,
      conflicts
    });
  }

  removeConflictFromActivePlanningConflicts(conflictId: string) {
    super.dispatchAndTransmitAction({
      type: ActionKeys.REMOVE_CONFLICT_FROM_ACTIVE_PLANNING_CONFLICTS,
      conflictId
    });
  }

  public chassisLockUpdate(chassisId: string, chassisLock: ChassisLock) {
    super.dispatchAndTransmitActionToGeneralChannel({
      type: ActionKeys.CHASSIS_LOCK_UPDATE,
      chassisLockUpdate: { chassisId, chassisLock}
    });
  }

}
